import MetricBase from "models/metrics/MetricBase";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricRevenuePerclickBing extends MetricBase {
    constructor() {
        super({
            field: "metric_revenue_per_click",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.revenuePerclick.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.revenuePerclick.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.revenuePerclick.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricRevenuePerclickBing;
